import { useAppDispatch, useAppSelector } from '@verantos-dev/core-annotation-tool';

import { setFilterBy } from '../../../state/annotationSlice';
import { selectFilterBy } from '../../../state/selector';

export interface UseFilterBySectionResult {
  filterBy: string;
  handleFilterByChange: (value: string) => void;
}

export const useFilterBySection = (): UseFilterBySectionResult => {
  const dispatch = useAppDispatch();
  const filterBy = useAppSelector(selectFilterBy);

  const handleFilterByChange = (value: string) => {
    dispatch(setFilterBy(value));
  };
  return { filterBy, handleFilterByChange };
};
